import React from "react";
import "./Footer.css";
import logo from "../Images/helloemslogo.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
function Footer() {
  const newYear = new Date().getFullYear();
  const handleFacebookClick = () => {
    window.open("https://www.facebook.com/ClotaTech", "_blank");
  };

  const handleInstagramClick = () => {
    window.open("https://www.instagram.com/ClotaTech/", "_blank");
  };

  const handleTwitterClick = () => {
    window.open(
      "https://x.com/i/flow/login?redirect_after_login=%2FClotaTech",
      "_blank"
    );
  };

  const handleLinkedInClick = () => {
    window.open("https://www.linkedin.com/company/clota-tech/", "_blank");
  };
  const handleWhatsAppClick = () => {
    const phoneNumber = "+919490384177";
    const message = "Hello!";

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="footersection">
      <img src={logo} alt="" />
      <p style={{ color: "#455a64" }}>
        &copy; Copyright {newYear}. Clota Technology. All Rights Reserved.
      </p>
      <div className="footer-icons">
        <FaFacebookF onClick={handleFacebookClick} />
        <FaInstagram onClick={handleInstagramClick} />
        <BsTwitterX onClick={handleTwitterClick} />
        <FaLinkedinIn onClick={handleLinkedInClick} />
        <FaWhatsapp onClick={handleWhatsAppClick} />
      </div>
    </div>
  );
}

export default Footer;
